import { toast } from "react-toastify";
import { NavigateFunction } from "react-router-dom";
import axios, { AxiosError } from "axios";
import { TokenDetailsResponse } from "../models/content-types/TokenDetailsResponse";
import { ssoLoginAPI, dealerDataUpdateAPI } from "./api";
import { RoleType } from "../models/content-types/RoleTypes";
import { logout } from "../Redux/LoginAction";
import axiosClient from "./axios";
import { DealerApiResponse, DealerData } from "../models/dbupdate-model/dealerDataUpdate";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const AutherizeSSOUser = async (JWTToken: string, navigate: NavigateFunction) => {
  try {
    const tokenResponse = await api.post<TokenDetailsResponse>(`${ssoLoginAPI}?token=${encodeURIComponent(JWTToken)}`);
    if (tokenResponse && tokenResponse.data) {
      const { email, expiresIn, role, name, validationMessage, accessToken } = tokenResponse.data;

      if (validationMessage === "Valid User") {
        let expiry = Date.now() / 1000;
        expiry = expiry + (expiresIn ?? 0);
        
        localStorage.setItem("authToken", JWTToken);
        localStorage.setItem("accessToken", accessToken ?? JWTToken);
        localStorage.setItem("expiresIn", expiry.toString());
        localStorage.setItem("email", email ?? "");
        localStorage.setItem("userName", name ?? "");
        localStorage.setItem("role", role ?? "");

        if (role === RoleType.Admin) {
          navigate("/dealerdataupdate");
        } else if (role === RoleType.SubaruUsers) {
          navigate("/dealerdataupdate");
        } else {
          toast.error("Invalid Token / Un-Autherized User");
          logout(navigate);
        }
      } else {
        toast.error("Invalid Token / Un-Autherized User");
        logout(navigate);
      }
    } else {
      toast.error("Invalid Token / Un-Autherized User");
      logout(navigate);
    }
  } catch (err: unknown) {
    if (err instanceof AxiosError) {
      toast.error(err.response?.data?.message);
      logout(navigate);
    } else {
      toast.error("An Expected Error Occured");
    }
  }
};

export const fetchDealerData = async (dealerNum: string): Promise<DealerApiResponse> => {
  const response = await axiosClient.get<DealerApiResponse>(
    `${dealerDataUpdateAPI}/${encodeURIComponent(dealerNum)}`
  );
  return response.data;
};

export const updateDealerData = async (dealerNum: string, data: DealerData): Promise<DealerApiResponse> => {
  const response = await axiosClient.put<DealerApiResponse>(
    `${dealerDataUpdateAPI}/${encodeURIComponent(dealerNum)}`,
    data
  );
  return response.data;
};